
<template>
  <!--新增工程账号-->
  <x-addEdit
    ref="form"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import { searchMobileOrAccount } from 'ant-design-vue-admin-x';
let decoratorOptions = {
  userName: {
    rules: [
      {required: true, message: '请输入账号名'},
      {min: 2, max: 30, message: '账号名为2-30位'}
    ]
  },
  mobile: {
    rules: [{required: true, message: '请输入手机号'}]
  },
  trueName: {
    rules: [
      {required: true, message: '请输入真实姓名'},
      {min: 1, max: 10, message: '真实姓名为1-10位'}
    ]
  },
  remarks: {
    rules: [{min: 2, max: 20, message: '描述信息为2-20位'}]
  }
};

export default {
  name: 'addProjectAccount',
  mixins: [searchMobileOrAccount],
  data () {
    return {
      formList: [
        {
          label: '账号名',
          inputType: 'input',
          options: [],
          placeholder: '请输入账号名',
          blur: e => this.searchMobileOrAccount(e, 'userName'),
          props: ['userName', decoratorOptions.userName]
        },
        {
          label: '手机号',
          inputType: 'input',
          options: [],
          placeholder: '请输入手机号',
          blur: e => this.searchMobileOrAccount(e, 'mobile'),
          props: ['mobile', decoratorOptions.mobile]
        },
        {
          label: '真实姓名',
          inputType: 'input',
          options: [],
          placeholder: '请输入真实姓名',
          props: ['trueName', decoratorOptions.trueName]
        },
        {
          label: '描述',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入描述信息',
          props: ['remarks', decoratorOptions.remarks]
        },
        {
          label: '状态',
          inputType: 'radioGroup',
          options: [
            { label: '正常', value: 1 },
            { label: '禁用', value: 0 }
          ],
          placeholder: '',
          props: ['status', {
            initialValue: 1,
            rules: []
          }]
        }
      ],
      formKey: {
        userName: '',
        mobile: '',
        trueName: '',
        remarks: '',
        status: ''
      },
      addParam: {
        url: '/project/user',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/project/user/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/project/user/',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  computed: {
  },
  created () {
    const routeQuery = this.$route.query.id;
    if (routeQuery) {
      let arr = this.formList.filter(item => item.props[0] === 'userName' || item.props[0] === 'mobile');
      arr.forEach((el) => { el.disabled = true; });
    }

    let mobileRules = this.formList[1].props[1].rules;
    routeQuery ? (mobileRules.splice(1, 1)) : (mobileRules.push({ pattern: this.REG.mobile, message: this.MESSAGE.mobile }));
    console.log(' project mobile Rules: ', mobileRules);
  },
  methods: {
    addResHandle (res) {
      return res;
    },
    reqHandle (param) {
      return param;
    },
    detailResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
